import classNames from 'classnames';
import { i18n } from '../../i18n/i18n';
import * as React from 'react';
import style from './datenauswertung.less'
import styleWForm from '../../core/forms/style/WForm.less'
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungJahrauswahlEinzelnProps extends React.ClassAttributes<any> {
    jahrMin: number;
    jahrMax: number;
    jahr: number;
    helpKey?: string;
    hideLabel?: boolean;
    widthLabel?: number;
    widthInput?: number;
    fontSize?: number;
    strLabel?: string;
    colLabel?: string;
    disabled?: boolean;
    noCheck?: boolean;
    data?: any;
    noFlex?: boolean;
    paddingTop?: number;
    externalHeaderElements?: JSX.Element[];
    jahrInputStyle?: React.CSSProperties;
    onJahrChange: (jahr: number) => void;
    renderClean?: boolean;
    className?: string;
}

interface DatenauswertungJahrauswahlEinzelnState {
    jahr: number;
}

export class DatenauswertungJahrauswahlEinzeln extends React.Component<DatenauswertungJahrauswahlEinzelnProps, DatenauswertungJahrauswahlEinzelnState> {

    constructor(props: any) {
        super(props);
        this.state = {
            jahr: this.props.jahr
        };
        this.onInput = this.onInput.bind(this);
        this.onChange = this.onChange.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.renderCleanElements = this.renderCleanElements.bind(this);
    }

    onInput(event: any): void {
        let jahr: number = +(event.target || {}).value || null;

        jahr = (jahr > 2009 && jahr < this.props.jahrMin)
            ? +this.props.jahrMin
            : (jahr > this.props.jahrMax ? +this.props.jahrMax : jahr);

        if (jahr !== +this.state.jahr) {
            this.setState({ jahr }, () => this.props.onJahrChange(jahr));
        }
    }

    changeYear(delta: number) {
        const currentYear = +(this.state.jahr) || new Date().getFullYear();
        const newYear = currentYear + delta;

        if (this.props.noCheck || (newYear >= +this.props.jahrMin && newYear <= +this.props.jahrMax)) {
            this.setState({ jahr: newYear }, () => {
                this.props.onJahrChange(newYear);
            });
        }
    }

    onChange(event: any) {
        const val = event.target.value;
        // Erlaube leere Eingabe (für Backspace) oder wandle in Zahl um
        const jahr = val === '' ? '' : +val;

        // 1. Update immer den lokalen State, damit das Tippen flüssig bleibt
        this.setState({ jahr: +jahr }, () => {
            // 2. Validierung für die Weitergabe nach außen (Props)
            const isVierstellig = ('' + jahr).length === 4;
            const isInRange = (+jahr >= this.props.jahrMin && +jahr <= this.props.jahrMax);

            if (this.props.noCheck || (isVierstellig && isInRange)) {
                this.props.onJahrChange(+jahr);
            }
        });
    }

    renderCleanElements(): JSX.Element {
        const currentJahr = +this.state.jahr || +this.props.jahr || +this.props.jahrMax;
        const hideUp = !this.props.noCheck && currentJahr >= +this.props.jahrMax;
        const hideDown = !this.props.noCheck && currentJahr <= +this.props.jahrMin;

        return <>
            {!this.props.hideLabel &&
                <label>
                    {this.props.strLabel || i18n('Jahr', 'sys')}
                </label>
            }
            <div className={style.datenauswertungNumberInputContainer}>
                <input
                    className={classNames(style.datenauswertungFormFieldInput, {
                        [style.hideUp]: hideUp,
                        [style.hideDown]: hideDown
                    })}
                    style={{
                        fontSize: this.props.fontSize && this.props.fontSize, width: this.props.widthInput && this.props.widthInput,
                    }}
                    type='number'
                    disabled={this.props.disabled}
                    value={this.state.jahr}
                    onChange={this.onChange}
                    onBlur = {() => {
                        let jahr = +this.state.jahr;
                        if (jahr < this.props.jahrMin) jahr = this.props.jahrMin;
                        if (jahr > this.props.jahrMax) jahr = this.props.jahrMax;
                        this.setState({ jahr }, () => this.props.onJahrChange(jahr));
                    }}
                />
                <div
                    className={classNames(style.datenauswertungArrowTrigger, style.datenauswertungArrowUp, {
                        [style.isHidden]: hideUp
                    })}
                    onClick={() => this.changeYear(1)}
                    title={i18n('Mehr', 'sys')}
                />
                <div
                    className={classNames(style.datenauswertungArrowTrigger, style.datenauswertungArrowDown, {
                        [style.isHidden]: hideDown
                    })}
                    onClick={() => this.changeYear(-1)}
                    title={i18n('Weniger', 'sys')}
                />
            </div>
        </>;
    }

    render(): JSX.Element {
        if (this.props.renderClean) {
            return this.renderCleanElements();
        }
        const col: string = this.props.colLabel
            ? this.props.colLabel
            : (this.props.disabled ? '#aaa' : '#000');
        const currentJahr: number = +this.state.jahr || +this.props.jahr || +this.props.jahrMax;
        const hideUp: boolean = !this.props.noCheck && currentJahr >= +this.props.jahrMax;
        const hideDown: boolean = !this.props.noCheck && currentJahr <= +this.props.jahrMin;

        return (
            <div
                style={{
                    marginRight: 10, boxSizing: 'border-box', display: 'flex', flex: this.props.noFlex ? 0 : 1, flexDirection: 'row',
                    alignItems: 'center'
                }}
            >
                {!this.props.hideLabel &&
                    <span
                        style={{
                            color: col, fontSize: this.props.fontSize && this.props.fontSize,
                            width: this.props.widthLabel && this.props.widthLabel, display: 'inline-block'
                        }}
                    >
                        {this.props.strLabel || `${i18n('Jahr', 'sys')}:`}
                    </span>
                }
                <div
                    className={styleWForm.inputNumberContainer}
                    style={{
                        padding: 5, paddingTop: this.props.paddingTop ? this.props.paddingTop : 5, ...(this.props.jahrInputStyle || {})
                    }}
                >
                    <input
                        style={{
                            fontSize: this.props.fontSize && this.props.fontSize, width: this.props.widthInput && this.props.widthInput,
                            boxSizing: 'border-box'
                        }}
                        className={this.props.className || null}
                        type='number'
                        disabled={this.props.disabled}
                        value={this.state.jahr}
                        onChange={this.onChange}
                        onBlur = {() => {
                            let jahr = +this.state.jahr;
                            if (jahr < this.props.jahrMin) jahr = this.props.jahrMin;
                            if (jahr > this.props.jahrMax) jahr = this.props.jahrMax;
                            this.setState({ jahr }, () => this.props.onJahrChange(jahr));
                        }}
                        // onChange={(event: any) => {
                        //     const jahr = event.target.value;
                        //     if (this.props.noCheck || (jahr >= this.props.jahrMin && jahr <= this.props.jahrMax)) {
                        //         this.props.onJahrChange(jahr);
                        //     }
                        // }}
                        // onInput={this.onInput}
                    />
                    <div
                        className={classNames(styleWForm.arrowUp, hideUp ? styleWForm.isHidden : null)}
                        onClick={() => this.changeYear(1)}
                        title={i18n('Mehr', 'sys')}
                    />
                    <div
                        className={classNames(styleWForm.arrowDown, hideDown ? styleWForm.isHidden : null)}
                        onClick={() => this.changeYear(-1)}
                        title={i18n('Weniger', 'sys')}
                    />
                </div>
                {(this.props.helpKey && this.props.data) &&
                    <div style={{ paddingTop: 0 }}>
                        <WHelpIcon
                            data={this.props.data}
                            styleDivProps={{ display: 'inline-block' }}
                            styleProps={{
                                width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0
                            }}
                            label='Hinweise'
                            helpKey={this.props.helpKey}
                            editBar
                            style='theme_small'
                            type='theme_info'
                            customElement='Info'
                            useTheme
                        />
                    </div>
                }
                {(this.props.externalHeaderElements || []).map((element: JSX.Element, index: number) =>
                    <div style={{ display: 'inline', marginLeft: 10 }} key={`elem-${index}`}>{element}</div>
                )}
            </div>
        );
    }
}
